import React, { Component, Fragment } from 'react';
// import PropTypes from 'prop-types';
// import Loader from 'js/components/global/Loader';
import ErrorModalWrapper from 'js/components/global/ErrorModalWrapper';
import constants from 'js/modules/constants';

// const { ERROR, FAIL, INVALID } = constants.STATUS;
const { SUCCESS, ERROR, FAIL, INVALID } = constants.STATUS;


// TODO: Remove this.
// const responseWrapper = {
//   width: '100%',
//   marginTop: '2rem',
//   background: '#bf360c',
//   color: '#fff',
//   borderRadius: '.4rem'
// };

// const responseBox = {
//   background: '#272b34',
//   color: '#fff',
//   padding: '2rem 3.3rem',
//   textAlign: 'left',
//   fontFamily: '\'Source Code Pro\', monospace',
//   overflow: 'scroll',
// };


class DataServiceCatcher extends Component {

  static getDerivedStateFromProps(props, state) {

    if (props.data !== state.data) {
      return { data: props.data };
    }

    return null;
  }

  state = {
    data: null,
  };

  componentDidMount() {
    const {data} = this.state;

    if(data) {
      const {content = {}} = data;

      if(Object.keys(content).length > 0) {
        const {invalidFields = {}} = content;

        const keys = Object.keys(invalidFields);

        if (keys.includes('rstCode')) {
          this.setState({clearSession: true});
        }
      }
    }
  }

  _handleClick = () => {
    const { continueAction = () => { return null; } } = this.props;
    const result = continueAction();

    if (result === null) {
      location.reload();
    }
  }

  _closeModal = () => {

    if(this.state.clearSession) {
      this._returnToHome();
    }

    if (this.props.cleanState) {
      this.props.cleanState();
    }
  }

  _returnToHome = () => {
    window.location.href = '/';
  }

  _generateFailJSX = (content, message, invalidFields) => {
    const brand = _app.brand || 's';

    let failJSX = (
      <Fragment>
        <p className="d-block">The server has replied with the following invalid fields:</p>
        {
          Object.keys(invalidFields).length > 0 ?
            <ul className="bullet-list d-inline-block">
              {
                Object.keys(invalidFields).map(field => {
                  let displayField = field !== '' ? `${field}:` : '';
                  let displayMessage = invalidFields[field];

                  if (displayField.includes('dob_guest')) {
                    displayField = '';

                    if (brand === 's') {
                      displayMessage = 'The secondary guest must be at least 18 years old at the time of travel.';
                    }
                  } else if (displayField.includes('age')) {
                    displayField = '';
                    displayMessage = 'The primary guest must be at least 18 years old at the time of travel.';
                  }

                  return <li key={`field-${field}`}>{displayField} {displayMessage}</li>;
                })
              }
            </ul>
            :
            <p>🤖 Bad Response Structure</p>
        }
      </Fragment>
    );

    if(message) {

      failJSX = (
        <Fragment>
          <p><strong>The server has replied with the following message:</strong></p>
          <p className="error-message-item">{message || 'Unable to proccess your request.'}</p>
        </Fragment>
      );

      if(content.infant_DoB) {
        failJSX = (
          <Fragment>
            <p>
              According to airline regulations, an "infant" is a child
              that is under two years of age for both the outbound and return flights.
              We require children's ages to correctly calculate the price for your air
              reservation. Please select "Continue" to re-quote air based on the age at the time
              of both the outbound and return flights.
            </p>
          </Fragment>
        );
      }
    }

    if(content.invalidFields !== undefined) {
      if(content.invalidFields.infant_seat_type) {
        failJSX = (
          <Fragment>
            <p className="d-block">
              The server has replied with the following message:
            </p>
            <p className="d-block">
              {invalidFields.infant_seat_type}
            </p>
          </Fragment>
        );
      }
    }

    if(message === 'INVALID ROOM SELECTED') {
      if(window.dtrum) {
        window.dtrum.reportCustomError(
          message + ' code:' + 'fail',
          content.message
        );

        const action = window.dtrum.enterAction('invalid room selected', 'step 2');

        window.dtrum.leaveAction(action);
      }
    }

    return failJSX;
  }

  _anyBackEndError(data = {}, status = FAIL, message = null) {

    const { content = {} } = data;
    const { invalidFields = {} } = content;
    // const stringifiedResponse = JSON.stringify(data, null, 2);
    // const invalidValues = content && Object.keys(content).map((item) => item);
    // const theString = invalidValues && invalidValues.join(', ');

    // console.log('data', data);
    // console.log('invalidValues', invalidValues);
    // console.log(theString);

    if(content.invalidFields && content.invalidFields.securityToken) {
      this._returnToHome();

      return null;
    }

    const options = ({
      [ERROR]: {
        title: 'OOPS...',
        content: <p>There was an error on the server side. Please contact customer service.</p>,
      },
      [INVALID]: {
        title: 'OOPS...',
        content: <p>Something went wrong, please refresh the page.</p>,
      },
      [FAIL]: {
        title: content.infant_DoB ? 'Important' : 'OOPS...',
        content: this._generateFailJSX(content, message, invalidFields),
      }
    })[status];

    if(message === 'INVALID ROOM SELECTED') {
      return (
        <Fragment>
          {this.props.children}
        </Fragment>
      );
    }

    return (
      <Fragment>
        {this.props.children}
        <ErrorModalWrapper
          // isOpen={this.state.isOpen}
          title={options.title}
          closeModal={this._closeModal}>
          <div className="util-txt-left error-content row">
            <div className="sm-12">

              {options.content}

              { !this.props.disabledButton &&
                <button className="btn-primary step1-continue" onClick={this._handleClick} data-testid="btn-refresh">
                  Continue
                </button>
              }
            </div>

            {/*
            =============================

            <div style={responseWrapper}>
              <h3>Development Only</h3>
              {status && <div className="sm-12"><strong>Status:</strong> <span>{status}</span></div>}
              {theString && <div className="sm-12"><strong>Invalid Fields:</strong> <span>{theString}</span></div>}
              {message && <div className="sm-12"><strong>Server Message:</strong> <span>{message}</span></div>}
              <strong className="sm-12 d-block">Stringified Response:</strong>
              <code className="sm-12">
                <pre style={responseBox}>
                  {stringifiedResponse}
                </pre>
              </code>
            </div>

            =============================
            */}
          </div>
        </ErrorModalWrapper>
      </Fragment>
    );
  }

  render() {

    const { data } = this.state;
    const { message = '', status = '' } = data || {};

    // Loading
    if (!status) {
      return this.props.children;
    }

    // All Good
    if (status === SUCCESS) {
      return this.props.children;
    }

    // this condition is only where aren't any room available for group codes"
    if(message === 'No Available Rooms for this Group Code') {
      return this.props.children;
    }

    // the logic to catch the button error must be here... maybe

    return this._anyBackEndError(data, status, message);

  }
}

// DataServiceCatcher.prototype = {
//   data: PropTypes.oneOfType([
//     PropTypes.oneOf([null]),
//     PropTypes.shape({
//       code: PropTypes.number,
//       message: PropTypes.string,
//       data: PropTypes.any,
//     }),
//   ])
// };

export default DataServiceCatcher;



// WEBPACK FOOTER //
// ./js/components/global/DataServiceCatcher.js